export default function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'rgba(0,0,0,0.3)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(2px)',
    }} onClick={onCancel}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: '24px 28px',
        width: 280, maxWidth: '85vw',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
      }} onClick={e => e.stopPropagation()}>
        <div style={{
          fontSize: 14, color: '#222', lineHeight: 1.6,
          textAlign: 'center', marginBottom: 20,
        }}>{message}</div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel} style={{
            flex: 1, padding: '8px 0', border: '1px solid #e0e0e0', borderRadius: 8,
            background: '#fff', color: '#888', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => e.target.style.background = '#f5f5f5'}
            onMouseLeave={e => e.target.style.background = '#fff'}
          >Cancel</button>
          <button onClick={onConfirm} style={{
            flex: 1, padding: '8px 0', border: 'none', borderRadius: 8,
            background: '#222', color: '#fff',
            fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            transition: 'opacity 0.15s',
          }}
            onMouseEnter={e => e.target.style.opacity = '0.85'}
            onMouseLeave={e => e.target.style.opacity = '1'}
          >Confirm</button>
        </div>
      </div>
    </div>
  );
}
